"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguage = void 0;
const react_i18next_1 = require("react-i18next");
const useLanguage = () => {
    const { t, i18n: { language = 'en' }, } = (0, react_i18next_1.useTranslation)();
    return ({
        t,
        language: language.slice(0, 2),
        isoCode: language, // language code
    });
};
exports.useLanguage = useLanguage;
//# sourceMappingURL=use-language.js.map